import i18n, { ensureLanguageResourcesLoaded } from "@/i18n/i18n";
import {
  DEFAULT_LANGUAGE,
  getSupportedLanguageFromPathname,
  normalizeLanguageCode,
} from "@/i18n/languages";

/**
 * Applies the language priority order:
 * 1. URL path language (if supported)
 * 2. Provided user locale (if supported)
 * 3. Default language fallback
 */
export const applyLanguagePriority = async (
  userLocale?: string,
): Promise<void> => {
  const supportedLngs = (i18n.options.supportedLngs as string[]) ?? [
    DEFAULT_LANGUAGE,
  ];

  // Priority 1: URL path language if supported
  const pathLanguage = getSupportedLanguageFromPathname(
    window.location.pathname,
  );
  if (pathLanguage && supportedLngs.includes(pathLanguage)) {
    await ensureLanguageResourcesLoaded(pathLanguage);
    await i18n.changeLanguage(pathLanguage);
    return;
  }

  // Priority 2: user locale if supported
  const normalizedLocale = normalizeLanguageCode(userLocale);
  if (normalizedLocale && supportedLngs.includes(normalizedLocale)) {
    await ensureLanguageResourcesLoaded(normalizedLocale);
    await i18n.changeLanguage(normalizedLocale);
    return;
  }

  // Priority 3: fallback to default
  await i18n.changeLanguage(DEFAULT_LANGUAGE);
};
